var _path, _radialGradient, _path2, _radialGradient2, _path3, _radialGradient3, _path4, _radialGradient4, _path5, _radialGradient5, _path6, _radialGradient6, _path7, _linearGradient, _path8, _linearGradient2, _path9, _g, _g2, _g3, _path10, _path11, _path12, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonShrugging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.78 69.65c-1.38-1.93-.2-4.2 1.95-7.11c3.41-4.61 6.51-14.69 1.36-23.93c.02-.06-.99-1.6-.97-1.65l-1.64.12c-.53-.01-18.43 2.14-36.35 4.32c-17.91 2.19-35.81 4.41-36.32 4.55c0 0-2.2 2.07-2.17 2.12c-2.77 10.2 2.66 19.25 7.08 22.9c2.78 2.3 4.49 4.22 3.6 6.43c-.85 2.14-4.09 2.83-4.09 2.83s1.01 1.96 2.96 2.85c1.81.82 3.91.81 5.34.67c0 0 6.54 7.06 21.15 5.27l8.13-1l8.13-.99C89.55 85.25 94.2 76.82 94.2 76.82c1.43-.21 3.46-.7 5.03-1.93c1.68-1.33 2.19-3.47 2.19-3.47s-3.3.1-4.64-1.77z",
    fill: "#232020"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18672",
    cx: 102.755,
    cy: 71.508,
    r: 21.447,
    gradientTransform: "matrix(.9926 -.1212 .0595 .4876 -27.686 51.577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.81 88.02l-1.05-8.58l25.72-5.23l2.72 2.62s-4.65 8.42-19.26 10.21l-8.13.98z",
    fill: "url(#IconifyId17ecdb2904d178eab18672)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18673",
    cx: 81.631,
    cy: 74.697,
    r: 6.338,
    gradientTransform: "matrix(-.8477 .5304 -.3935 -.6289 197.742 71.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#444140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.69 73.08c-4.61-5.43 3.75-8.69 3.75-8.69h.01c-1.27 2.05-1.76 3.76-.68 5.26c1.35 1.87 4.66 1.77 4.66 1.77s-3.98 4.51-7.74 1.66z",
    fill: "url(#IconifyId17ecdb2904d178eab18673)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18674",
    cx: 98.058,
    cy: 92.627,
    r: 27.84,
    gradientTransform: "matrix(-.1949 -.9808 .8175 -.1624 24.056 163.683)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.11 38.61c5.01 8.94 2.13 19.13-1.18 23.68c-.45.62-2.4 3.07-2.69 4.87c0 0-10.15-11.04-13.61-17.83c-.7-1.37-1.36-2.79-1.6-4.31c-.19-1.14-.18-2.52.36-3.57c.66-1.29 18.14-3.78 18.14-3.78l.58.94z",
    fill: "url(#IconifyId17ecdb2904d178eab18674)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18675",
    cx: 44.079,
    cy: 92.627,
    r: 27.84,
    gradientTransform: "matrix(-.0467 -.9989 -.8325 .039 124.024 97.253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.65 48.06c-2.71 9.88 2.53 19.08 6.84 22.7c.59.5 3.07 2.4 3.79 4.08c0 0 7.2-13.15 8.92-20.58c.35-1.5.64-3.03.52-4.57c-.09-1.15-.44-2.49-1.21-3.38c-.95-1.09-1.86-.66-3.23-.49c-2.62.32-14.16 1.05-15.05 1.16c0 .01-.58 1.08-.58 1.08z",
    fill: "url(#IconifyId17ecdb2904d178eab18675)"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18676",
    cx: 48.776,
    cy: 71.508,
    r: 21.447,
    gradientTransform: "matrix(-.9926 .1212 .0595 .4876 96.236 36.452)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.85 88.01l-1.05-8.58l-26.23 1.11l-2.01 3.19S44.1 90.79 58.71 89l8.14-.99z",
    fill: "url(#IconifyId17ecdb2904d178eab18676)"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18677",
    cx: 27.653,
    cy: 74.697,
    r: 6.338,
    gradientTransform: "matrix(.9504 .311 .2307 -.7051 -12.797 120.696)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#444140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140",
    stopOpacity: 0
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.17 79.98c3.17-6.38-5.73-7.53-5.73-7.53l-.01.01c1.73 1.68 2.61 3.23 1.92 4.94c-.85 2.14-4.09 2.83-4.09 2.83s4.95 3.41 7.91-.25z",
    fill: "url(#IconifyId17ecdb2904d178eab18677)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab18678",
    gradientUnits: "userSpaceOnUse",
    x1: 16.398,
    y1: 54.489,
    x2: 16.398,
    y2: 84.711,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70534a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c4037"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 62.35a38.066 38.066 0 0 1-6.08-5.66c-.95-1.05-2.83-2.78-4.69-2.62c-.38.03-.87.16-1.34.51c-1.27-1.64-4.2-6.04-5.66-9.92c-.59-1.23-1.62-1.43-2.33-1.23c-1.26.37-2.07 1.97-1.88 3.74c.62 5.9 5.24 13.09 6.97 14.78l-.03.02c3.4 4.14 3.72 10.18 3.72 10.24c.02.47.37.86.83.94l9.51 1.59c.06.01.11.01.17.01c.42 0 .81-.27.94-.68c.63-1.85 2.09-6.25 2.11-7.25c.06-2.92-1.79-4.2-2.24-4.47z",
    fill: "url(#IconifyId17ecdb2904d178eab18678)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab18679",
    gradientUnits: "userSpaceOnUse",
    x1: 111.822,
    y1: 55.186,
    x2: 111.822,
    y2: 84.222,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#70534a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c4037"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.08 43.45c-.71-.22-1.77-.02-2.41 1.31c-1.43 3.8-4.36 8.19-5.63 9.83a2.68 2.68 0 0 0-1.34-.51c-1.86-.16-3.74 1.57-4.7 2.63a37.9 37.9 0 0 1-6.07 5.64c-.45.27-2.3 1.54-2.24 4.48c.02 1 1.48 5.41 2.11 7.25c.14.41.52.68.94.68c.06 0 .11 0 .17-.01l9.51-1.59a.99.99 0 0 0 .83-1.06c0-.05-.34-5.39 3.71-10.11l-.03-.02c1.73-1.68 6.2-9.03 6.98-14.77c.24-1.75-.55-3.37-1.83-3.75z",
    fill: "url(#IconifyId17ecdb2904d178eab18679)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab18680",
    gradientUnits: "userSpaceOnUse",
    x1: 64.065,
    y1: 45.986,
    x2: 64.065,
    y2: 0.64,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#f47f12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#ef6c00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.74 111.06c.14 7.1-5.58 12.94-12.69 12.94c-1.4 0-2.72-.29-3.9-.84c-.04-.02-.08-.03-.11-.05a8.03 8.03 0 0 1-1.65-.97a9.795 9.795 0 0 1-1.89-1.86a9.44 9.44 0 0 1-1.91-4.59l-.02.01l-.01.01V124H34.58v-8.41l-.04-.02c0 .02 0 .03-.01.04v.01c-.43 3.23-2.5 6-5.39 7.36h-.01c-1.23.58-2.59.9-4.05.9c-7.1 0-12.83-5.83-12.69-12.94l.11-40.55c.02-.8.65-1.45 1.45-1.5l12.81-.75h.11c.78 0 1.45.59 1.54 1.38l2.68 18.97c4.18-3.58 9.95-6.21 17.88-6.21c2.62 0 27.59.12 30.2.12c7.93 0 13.7 2.63 17.88 6.2l2.67-18.97c.1-.79.77-1.38 1.55-1.38c.04 0 .07.01.11.01l12.81.75c.8.05 1.42.7 1.45 1.5l.1 40.55z",
    fill: "url(#IconifyId17ecdb2904d178eab18680)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.04 123.11a8.03 8.03 0 0 1-1.65-.97a9.795 9.795 0 0 1-1.89-1.86a9.44 9.44 0 0 1-1.91-4.59l-.02.01l-.38-10.68s.63 9.15 5.85 18.09z",
    fill: "#da6727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.91 105.02l-.38 10.59v.01c-.43 3.23-2.5 6-5.39 7.36c5.14-8.9 5.77-17.96 5.77-17.96z",
    fill: "#da6727"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.92 78.33v9.98c0 4.51 3.62 8.17 9.08 8.17s9.08-3.66 9.08-8.17v-9.98H54.92z",
    fill: "#3c2b24"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.49 43.78l-49.72 6.05c-5.36.65-9.18 5.86-8.48 11.57c.69 5.71 5.65 9.85 11.01 9.2l49.72-6.05c5.36-.65 9.18-5.86 8.48-11.57c-.69-5.71-5.65-9.85-11.01-9.2z",
    fill: "#3c2b24"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.28 10.99C41.44 12.92 28.84 31.63 31.81 56c2.95 24.23 19.51 34.38 34.9 32.51S95.75 72.82 92.8 48.58C89.83 24.21 73.11 9.07 57.28 10.99z",
    fill: "#70534a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.05 75.72c.22 2.78-2.21 3.55-5.27 3.79c-3.06.24-5.58-.21-5.8-2.92c-.22-2.86 2.12-4.82 5.17-5.06c3.06-.24 5.67 1.28 5.9 4.19z",
    fill: "#1a1717"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1 62.41c-.1-.03-.2-.04-.3-.04l-6.44.78c-.1.02-.19.06-.28.11c-.56.31-.8.95-.45 1.56c.35.61 1.85 2.26 4.44 1.95c2.58-.31 3.64-2.28 3.84-2.95c.19-.68-.2-1.24-.81-1.41z",
    fill: "#33251f"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#1a1717"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-6.851 47.543 56.444)",
    cx: 47.55,
    cy: 56.45,
    rx: 4.49,
    ry: 4.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-6.851 77.317 52.867)",
    cx: 77.32,
    cy: 52.87,
    rx: 4.49,
    ry: 4.65
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#1a1717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.17 47.35c-.98-1.02-3.15-2.42-6.96-1.97c-3.81.46-5.58 2.33-6.3 3.56c-.32.54-.15 1.1.15 1.42c.28.29 1.03.51 1.78.15s2.2-1.34 4.78-1.67c2.58-.29 4.22.32 5.03.49c.82.17 1.5-.21 1.7-.56c.23-.38.26-.97-.18-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.95 43.77c-.98-1.02-3.15-2.42-6.96-1.97c-3.81.46-5.58 2.33-6.29 3.56c-.32.54-.15 1.1.15 1.42c.28.29 1.03.51 1.79.15s2.2-1.34 4.78-1.67c2.58-.29 4.22.32 5.03.49c.82.17 1.5-.21 1.7-.56c.21-.38.23-.97-.2-1.42z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.41 19.32c-2.63-3.09-8.15-6.98-12.65-6.73c-1.24-4.2-6.28-7.28-10.89-8.14c-12.49-2.34-19.8 2.88-23.72 5.69c-.82.58-6.08 4.4-10.3 2.64c-2.64-1.1-3.06-4.92-3.06-4.92s-7.39 3.9-3.74 11.8c-2.65.43-6 1.98-7.4 5.95c-1.66 4.72-.42 8.35.43 10.05c-2.06 2.22-4.43 6.72-1.8 11.85c1.98 3.86 8.15 5 8.15 5c.47 7.33 2.38 11.65 3.32 13.38c.16.3.61.22.65-.12c.46-3.71 1.99-16.66 1.42-18.82c0 0 10.06-3.31 19.02-11.75c1.82-1.72 3.84-3.24 6.03-4.44c11.75-6.43 15.36 1.65 15.36 1.65s8.36-2.69 12.4 8.89c1.51 4.34 3.05 11.39 4.2 16.32c.08.35.57.36.67.02c.62-2.08 1.87-6.23 1.79-10.28c-.03-1.43 3.55-3.76 4.44-10.01c1.21-8.37-2.42-15.8-4.32-18.03z",
    fill: "#232020"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18681",
    cx: 78.613,
    cy: 107.313,
    r: 32.633,
    gradientTransform: "matrix(.4206 .9072 .6731 -.3121 -27.946 .247)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.28 47.37c-.03-1.43 3.55-3.76 4.44-10.01c.1-.67.16-1.34.22-2.01c.43-7.52-2.78-13.98-4.53-16.03c-2.43-2.85-7.33-6.39-11.61-6.71c-.37 0-.73 0-1.07.02c0 0 .54 1.91-.06 3.57c-.77 2.14-2.79 2.88-2.79 2.88c12.21 9.55 12.54 18.75 15.4 28.29z",
    fill: "url(#IconifyId17ecdb2904d178eab18681)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18682",
    cx: 46.799,
    cy: 142.895,
    r: 8.556,
    gradientTransform: "matrix(.9321 .3623 .4296 -1.1051 -63.546 147.566)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#444140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.61 8.44c-.94.6-1.76 1.19-2.46 1.69c-.82.58-6.08 4.4-10.3 2.64c-2.6-1.09-3.05-4.78-3.06-4.91c-.94 1.56-3.08 12.17 6.89 11.64c4.3-.23 6.47-4.26 7.65-7.61c.41-1.2 1.09-2.98 1.28-3.45z",
    fill: "url(#IconifyId17ecdb2904d178eab18682)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18683",
    cx: 139.535,
    cy: 52.551,
    r: 26.303,
    gradientTransform: "matrix(-.9787 -.2779 -.1526 .551 206.907 29.538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.58 4.22c6.87.99 10.53 3.98 12.17 8.37c.48 1.29 2.37 13.62-22.98 2.44c-9.43-4.16-7.43-7.73-6.45-8.23c3.84-1.94 9.56-3.68 17.26-2.58z",
    fill: "url(#IconifyId17ecdb2904d178eab18683)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18684",
    cx: 43.364,
    cy: 135.089,
    r: 7.854,
    gradientTransform: "matrix(.9926 -.1212 -.1482 -1.2143 15.973 184.066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.75 7.87c-.01.01-.03.02-.05.03c-.8.46-7.08 4.35-3.65 11.75l7.22.28c-7.03-5.59-3.48-12.08-3.48-12.08s-.03.01-.04.02z",
    fill: "url(#IconifyId17ecdb2904d178eab18684)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18685",
    cx: 42.283,
    cy: 121.227,
    r: 14.729,
    gradientTransform: "matrix(-.99 -.1409 -.1319 .9265 97.455 -77.693)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 19.82l-4.46-.17c-.17.02-.75.15-1.06.23c-2.42.64-5.17 2.27-6.34 5.72c-1.26 3.71-.85 6.72-.15 8.67c.21.66.58 1.38.58 1.38s1.92-2.32 7.05-3.08l4.38-12.75z",
    fill: "url(#IconifyId17ecdb2904d178eab18685)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab18686",
    cx: 38.789,
    cy: 107.004,
    r: 15.464,
    gradientTransform: "matrix(.9999 .0153 .0215 -1.4051 -3.227 192.966)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#444140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444140"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.9 35.86c-1.92 2.17-4.3 6.79-1.52 11.82c2.1 3.79 8.06 4.82 8.06 4.82c0 .02 1.19.22 1.78.15l-1.08-20.07c-2.75.34-5.3 1.48-6.86 2.88c.01.03-.4.37-.38.4z",
    fill: "url(#IconifyId17ecdb2904d178eab18686)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonShrugging);
export default __webpack_public_path__ + "static/media/person-shrugging.608dbb7544a92b0f743f0aacada1a9a8.svg";
export { ForwardRef as ReactComponent };